import { EventEmitter, OnChanges } from '@angular/core';
import { ThemeConfig } from '../../../core/helpers/theme-config';
import { minQuantity, stepping, unitPrice, upwardsQuantity } from '../../../core/helpers/prices';
import { Product } from '../../../core/models/product';
import { CartProduct } from '../../../cart/models/cart-models';
import { canBuyProduct } from '../../../core/helpers/product';
import { Image } from 'angular-modal-gallery';
import chaining from '../../../core/helpers/chaining';
import { CombinedFacets } from '../../../facets/models/facet';
import findTileFacets from '../../../core/helpers/tile-facet';
var hasDetails = ThemeConfig.get('catalog', 'has-details');
var isTileOrderable = ThemeConfig.get('catalog', 'is-tile-orderable');
var ProductTileComponent = /** @class */ (function () {
    function ProductTileComponent() {
        this.startQuantity = 0;
        this.onDetails = new EventEmitter();
        this.onAddCart = new EventEmitter();
        this.onFavoriteToggle = new EventEmitter();
    }
    ProductTileComponent.prototype.ngOnChanges = function () {
        this.getProductImage();
        this.getActualQuantity(this.cartProduct && this.cartProduct.quantity);
    };
    ProductTileComponent.prototype.getProductImage = function () {
        if (this.product && this.product.assets && this.product.assets.imgs)
            this.productImage = new Image(+new Date(), {
                img: (this.product.assets.imgs
                    .find(function (img) { return img.type === 'detail'; }) || {})
                    .src
            });
    };
    ProductTileComponent.prototype.getActualQuantity = function (cartQuantity) {
        this.startQuantity = cartQuantity > 0
            ? cartQuantity
            : 0;
    };
    Object.defineProperty(ProductTileComponent.prototype, "hasPrice", {
        get: function () {
            return !!(this.product && this.product.price);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "productFacets", {
        get: function () {
            return findTileFacets(chaining(this.catalogItemPageSettings, 'showFacets'), chaining(this.product, 'facets'), this.combinedFacets);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "name", {
        get: function () {
            return this.product.name || 'No Name';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "code", {
        get: function () {
            return this.product.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "displayCode", {
        get: function () {
            return this.product.displayCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "prices", {
        get: function () {
            return this.product.price.prices;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "currentPrice", {
        get: function () {
            return unitPrice(this.product, this.actualQuantity || this.minQuantity);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "stepping", {
        get: function () {
            return stepping(this.product);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "actualStepping", {
        get: function () {
            return this.product.price.stepping;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "minQuantity", {
        get: function () {
            return minQuantity(this.product);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "actualQuantity", {
        get: function () {
            return upwardsQuantity(this.product, this.quantity || this.startQuantity);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "hasMultiplePrices", {
        get: function () {
            return chaining(this.prices, 'length') > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "hasDetails", {
        get: function () {
            return hasDetails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "isInCart", {
        get: function () {
            return (this.actualQuantity > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "isTileOrderable", {
        get: function () {
            return isTileOrderable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "canBuy", {
        get: function () {
            return canBuyProduct(this.product, this.allowOutOfStockOrdering);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "showQuantityPickerAnimated", {
        get: function () {
            return (this.quantityPicker && this.quantityPicker.toLowerCase() === 'animated');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "quantityPickerRelative", {
        get: function () {
            return (this.quantityPicker && this.quantityPicker.toLowerCase() === 'relative');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "isProductInBackorder", {
        get: function () {
            return (this.product && this.product.backorderInfo && this.product.backorderInfo.totalInBackorder > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTileComponent.prototype, "isProductPreviouslyOrdered", {
        get: function () {
            return (this.product && this.product.totalPreviouslyOrdered && this.product.totalPreviouslyOrdered > 0);
        },
        enumerable: true,
        configurable: true
    });
    ProductTileComponent.prototype.quantityChanged = function (event) {
        this.startQuantity = chaining(event, 'quantity');
        this.onAddCart.emit({
            product: chaining(this, 'product._id'),
            quantity: chaining(event, 'quantity')
        });
    };
    ProductTileComponent.prototype.openDetails = function () {
        if (!hasDetails)
            return;
        this.onDetails.emit(this.product);
    };
    ProductTileComponent.prototype.toggleFavorite = function (e) {
        e.stopPropagation();
        this.onFavoriteToggle.emit({
            isFavorite: this.isFavorite,
            product: this.product
        });
    };
    ProductTileComponent.prototype.onImageError = function (url) {
        this.imgUrl = url;
    };
    return ProductTileComponent;
}());
export { ProductTileComponent };
